import React from "react"

import { Link } from "gatsby"

import withRecombee from "../contexts/withRecombee"

import DebouncedInput from "../helpers/DebouncedInput"

import search from "../images/search.svg"

import * as searchWidgetStyles from "../styles/StandaloneSearchWidget.module.css"

function StandaloneSearchWidget(props) {
  const [isOpen, setIsOpen] = React.useState(true)
  const [isSearching, setIsSearching] = React.useState(false)
  const [results, setResults] = React.useState([])

  const { wordpressUrl } = props.pageContext

  const onDataInput = async ({ value }) => {
    if (!value) return setResults([])

    setIsSearching(true)

    if (false && !props.recombee) {
      // de-activate recombee for the moment
      setTimeout(function () {
        setResults([])
        setIsSearching(false)
      }, 1000)
    } else {
      try {
        const res = await fetch(
          `${wordpressUrl}/wp-json/wp/v2/search/?search="${encodeURI(
            value,
          )}"&_fields[]=id&_fields[]=title&_fields[]=url&_fields[]=excerpt&per_page=5`,
        )
        const data = await res.json()
        console.log(data)
        setResults(
          data.map(r => ({
            title: r.title,
            synopsis: r.excerpt || ``,
            link: (r.url && new URL(r.url).pathname) || ``,
          })),
        )
        setIsSearching(false)
      } catch (_error) {
        setResults([])
        setIsSearching(false)
      }
    }
  }

  return (
    <div className={searchWidgetStyles.wrapper}>
      {!isOpen && (
        <a
          className={searchWidgetStyles.toggle}
          href="#!"
          onClick={evt => {
            evt.preventDefault()
            setIsOpen(!isOpen)
          }}
        >
          <img src={search} alt="global-search" />
        </a>
      )}

      {isOpen && (
        <div
          className={`row ${props.className} ${searchWidgetStyles.wrapperOpen}`}
        >
          <div className={`col-12 ${searchWidgetStyles.holder}`}>
            <div className={searchWidgetStyles.widget}>
              <span className={`col-12 ${searchWidgetStyles.widgetInput}`}>
                <DebouncedInput
                  className={`col-12 ${searchWidgetStyles.searchField}`}
                  placeholder={`Search Cubewise for solutions, education and support`}
                  initialValue={``}
                  isReadOnly={isSearching}
                  onDataInput={onDataInput}
                />
                <span style={{ display: "flex" }}>
                  <div
                    className={`spinner-border text-dark ${
                      isSearching
                        ? searchWidgetStyles.spinnerActive
                        : searchWidgetStyles.spinnerInactive
                    }`}
                    role="status"
                  ></div>
                </span>
              </span>
              <div className={searchWidgetStyles.results}>
                {/* <hr className={searchWidgetStyles.resultsSeparator} /> */}
                <ul className={searchWidgetStyles.resultEntryList}>
                  {results &&
                    results.map((res, idx) => (
                      <li key={idx} className={searchWidgetStyles.resultEntry}>
                        <Link
                          className={searchWidgetStyles.resultEntryLink}
                          to={res.link}
                        >
                          <p className={searchWidgetStyles.resultEntryTitle}>
                            {res.title}
                          </p>
                          <p className={searchWidgetStyles.resultEntrySynopsis}>
                            {res.synopsis}
                          </p>
                        </Link>
                      </li>
                    ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default withRecombee(StandaloneSearchWidget)
